export function formatLayers (layers: string[]) {
    return `["${layers.join('","')}"]`
}
